import { createContext, useContext } from "react";
import { useActor, useSelector } from "@xstate/react";
import { State, EventObject, Sender, Interpreter } from "xstate";

export const AuthMachine = createContext<
  Interpreter<unknown, unknown, EventObject> | undefined
>(undefined);

type Selector<IReturnType, IContext> = (state: State<IContext>) => IReturnType;

export function useAuthState<IEvent extends EventObject, IContext>(): [
  State<IContext>,
  Sender<IEvent>,
] {
  const ctx = useContext(AuthMachine);
  if (ctx === undefined) {
    throw new Error(`must be used within a AuthMachine`);
  }
  return useActor(ctx as Interpreter<IContext, unknown, IEvent>);
}

export function useAuthSelector<IReturnType, IContext>(
  selector: Selector<IReturnType, IContext>
) {
  const ctx = useContext(AuthMachine);

  if (ctx === undefined) {
    throw new Error(`must be used within a AuthMachine`);
  }
  return useSelector(
    ctx as Interpreter<IContext, unknown, EventObject>,
    selector
  );
}
